import React, { useState, useRef, useEffect, Suspense, useMemo } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import reactWrapper from "@harbor/elements/utils/react/wrapper";
import ApiService from "../../../config/api-config";
import AppHOC from "../../../generics/AppHOC";
import InsightsModal from "./InsightsModal";
import InsightsMessage from "./InsightsMessage";
const ErrorComponent = React.lazy(
  () => import("../../../common/ErrorComponent"),
);
const NoDataAvailable = React.lazy(
  () => import("../../../common/NoDataAvailable"),
);
import { useI18n } from "../../../i18n/useI18n";
import Spinner from "../../../common/Spinner";
import { useMount } from "../../../utils/genericCommon";
import { getInsightsAccess } from "../../../utils/license";

//styles
import css from "../overviewMagneticStyle.less";
import FeatureDisabled from "../../../generics/authorization/FeatureDisabled";

const mapStateToProps = (state) => {
  return {
    overview: state.vanalytics.overview,
  };
};

const [HbrBadge, HbrSelect, HbrOption, HbrPagination, HbrAccordion] =
  reactWrapper([
    "hbr-badge",
    "hbr-select",
    "hbr-option",
    "hbr-pagination",
    "hbr-accordion",
  ]);

const InsightsView = (props) => {
  const { tViews } = useI18n("views");
  const insightsAccess = useMemo(() => getInsightsAccess(), []);
  const mount = useMount();
  const { globalFilter } = props;
  const {
    notificationInsightLoader,
    notificationInsightError,
    notificationInsight,
  } = globalFilter;
  const refNotificationInsightModal = useRef(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [featuresEnabled, setFeaturesEnabled] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState();
  const [pageStart, setPageStart] = useState(0);
  const [pageEnd, setPageEnd] = useState(3);
  const [pageNo, setPageNo] = useState(0);
  const [filterDropdown, setFilterDropdown] = useState();
  const [insightData, setNotificationInsightData] = useState();
  const [filterValue, setFilterValue] = useState(tViews("notificationAll"));
  const [insightsCount, setInsightsCount] = useState();
  const [isAccordianOpen, setIsAccordianOpen] = useState(false);
  const currentTab = localStorage.getItem("currentPath");

  useEffect(() => {
    const el = document.querySelector(".react-grid-layout");
    if (insightsAccess.available && globalFilter.selectedSite === -1) {
      el.style.height = "350px";
    } else {
      el.style.height = "290px";
    }
  }, [globalFilter.selectedSite, globalFilter.selectedNhName, currentTab]);

  useEffect(() => {
    if (
      (!mount.initMount ||
        globalFilter.selectedOverlay !==
          globalFilter.notificationInsightOverlay) &&
      globalFilter.features.enabled.includes("insights") &&
      globalFilter.selectedSite === -1
    ) {
      props.setNotificationInsightLoader(true);
      ApiService.getOverviewNotificationInsights().then((res) => {
        if (res && !res.errorObject) {
          const resultAPI = {
            insightList: res.data.data,
            selectedOverlay: globalFilter.selectedOverlay,
          };
          resultAPI.insightList.sort(
            (a, b) => new Date(a.created_at) - new Date(b.created_at),
          );
          props.setNotificationInsight(resultAPI);
        } else {
          props.setNotificationInsightError(res);
        }
      });
    } else {
      setFeaturesEnabled(true);
    }
    mount.initMount = false;
  }, [
    globalFilter.selectedOverlay,
    globalFilter.currentTimeStamp,
    insightsAccess.available,
    globalFilter.selectedSite,
    globalFilter.selectedNhName,
  ]);

  // set modal open and set notification message
  const modalAction = (notification) => {
    setNotificationMessage(notification);
    setModalOpen(true);
  };

  // modal close handler
  const modalActionClose = (value) => {
    setModalOpen(value);
  };

  // click of pagination handler
  const pageHandler = (event) => {
    const perPage = 3;
    const pageStart = event.detail * perPage;
    const pageEnd = (event.detail + 1) * 3;
    setPageStart(pageStart);
    setPageEnd(pageEnd);
    setPageNo(event.detail);
  };

  // insights filter change handler
  const onFilterChange = (event) => {
    setFilterValue(event.target.value);
    let storeNotificationData = [...notificationInsight];
    if (
      event.target.value !== "" &&
      event.target.value !== tViews("notificationAll")
    ) {
      const result =
        storeNotificationData &&
        storeNotificationData.filter(
          (insights) => insights.title == event.target.value,
        );
      setNotificationInsightData(result);
      setInsightsCount(result.length);
    } else {
      setNotificationInsightData(storeNotificationData);
      setInsightsCount(storeNotificationData.length);
    }
    // reset pagination
    setPageStart(0);
    setPageEnd(3);
    setPageNo(0);
  };

  // when insights api update store data,this dependency will trigger and
  // set local state and dropdown list
  useEffect(() => {
    const runEffect = async () => {
      let notificationDropDownList = [tViews("notificationAll")];
      if (notificationInsight && notificationInsight.length > 0) {
        notificationInsight.map((list) => {
          let indexData = notificationDropDownList.indexOf(list.title);
          if (indexData === -1) {
            notificationDropDownList.push(list.title);
          }
        });
        setFilterDropdown(notificationDropDownList);
        setNotificationInsightData(notificationInsight);
        setInsightsCount(notificationInsight.length);
        setIsAccordianOpen(true);
      } else {
        setNotificationInsightData({});
        setInsightsCount(0);
        setFilterDropdown(notificationDropDownList);
        setIsAccordianOpen(false);
      }
    };

    runEffect();
  }, [notificationInsight]);

  // Insights features enabled set to show and hide the widget
  useEffect(() => {
    if (
      globalFilter.features.enabled.length > 0 &&
      globalFilter.features.enabled.includes("insights")
    ) {
      setFeaturesEnabled(false);
    } else {
      setFeaturesEnabled(true);
    }
  }, [globalFilter.features.enabled]);

  useEffect(() => {
    const el = document.querySelector(".react-grid-layout");
    if (insightsAccess.available && globalFilter.selectedSite === -1) {
      el.style.height = "350px";
    } else {
      el.style.height = "290px";
    }
  }, []);

  const onHbrShow = (event) => {
    if (event.target.nodeName === "HBR-ACCORDION") {
      setIsAccordianOpen(true);
      const el = document.querySelector(".react-grid-layout");
      const expToggle = document.querySelector(
        ".overview-notification-summary",
      );
      if (el) {
        if (!notificationInsightError) {
          el.style.height = "580px";
          expToggle.style.setProperty("--base-height", "280px");
        } else {
          el.style.height = "680px";
        }
      }
    }
  };

  const onHbrHide = (event) => {
    if (event.target.nodeName === "HBR-ACCORDION") {
      setIsAccordianOpen(false);
      const el = document.querySelector(".react-grid-layout");
      el.style.height = "350px";
    }
  };

  return (
    <>
      {insightsAccess.available === true &&
        globalFilter.selectedSite === -1 && (
          <div
            className={
              isAccordianOpen
                ? css["overviewInsightsView"]
                : css["overviewInsightsViewToggleClose"]
            }
          >
            <HbrAccordion
              variant="stacked"
              className="overview-notification-summary"
              onHbr-show={onHbrShow}
              onHbr-hide={onHbrHide}
              open={isAccordianOpen}
            >
              <div className="main-header" slot="label">
                <div className="hbr-css__layout-row-base hbr-type-h2 hbr-css__custom-heading">
                  {tViews("notificationInsights")}
                  <HbrBadge
                    className="insight-header-badge"
                    pill
                    size="small"
                    style={{ marginLeft: "5px", marginTop: "3px" }}
                  >
                    {tViews("totalInsightsCount", { insightsCount })}
                  </HbrBadge>
                </div>
              </div>
              {featuresEnabled ? (
                <div className="featureDisabled">
                  <FeatureDisabled size={"medium"} />
                </div>
              ) : notificationInsightLoader ? (
                <div
                  className="spinner-component-site-view"
                  data-cy="spinner-component-site-view"
                >
                  <Spinner />
                </div>
              ) : notificationInsightError ? (
                <Suspense fallback={<Spinner />}>
                  <ErrorComponent
                    {...notificationInsightError}
                    width={"210px"}
                    className={"small-dashlet-error"}
                  />
                </Suspense>
              ) : (
                <div
                  className="overview-notification-summary-insights"
                  data-cy="overview-notification-summary-insights"
                >
                  <div className="insight-main-card">
                    <div
                      data-cy="timeFilterDropDown"
                      className={
                        insightData && insightData.length > 0
                          ? "insights-filter-dropdown"
                          : "insights-filter-dropdown-hidden"
                      }
                    >
                      <HbrSelect
                        className="insights-filter-select"
                        onHbr-change={onFilterChange}
                        value={filterValue}
                      >
                        {filterDropdown &&
                          filterDropdown.map((option) => (
                            <HbrOption
                              key={option}
                              value={option}
                              allowSpace={true}
                            >
                              {option}
                            </HbrOption>
                          ))}
                      </HbrSelect>
                    </div>
                  </div>

                  <div>
                    {modalOpen && notificationMessage && (
                      <InsightsModal
                        refNotificationInsightModal={
                          refNotificationInsightModal
                        }
                        notificationMessage={notificationMessage}
                        modalActionClose={modalActionClose}
                      />
                    )}
                  </div>
                  <div className="insights-display-flex">
                    {insightData &&
                      insightData.length > 0 &&
                      insightData
                        .slice(pageStart, pageEnd)
                        .map((notification, index) => (
                          <div key={index} className="insights-message">
                            <InsightsMessage
                              {...props}
                              modalAction={modalAction}
                              refNotificationInsightModal={
                                refNotificationInsightModal
                              }
                              notificationMessage={notification}
                              indexValue={index}
                              isAccordianOpen={isAccordianOpen}
                            />
                          </div>
                        ))}
                    {insightData && insightData.length === undefined && (
                      <div className="insights-message-nodata">
                        <Suspense fallback={<Spinner />}>
                          <NoDataAvailable
                            text={tViews("notificationNoInsightsData")}
                          />
                        </Suspense>
                      </div>
                    )}
                    {notificationInsightError && (
                      <Suspense fallback={<Spinner />}>
                        <ErrorComponent
                          {...notificationInsightError}
                          width={"210px"}
                          className={"small-dashlet-error"}
                        />
                      </Suspense>
                    )}
                  </div>
                  {insightData && insightData.length > 0 && (
                    <HbrPagination
                      className="insights-pagination"
                      pageSize={3}
                      page={pageNo}
                      itemCount={insightData && insightData.length}
                      sizeChanger={false}
                      orderArray={[2, 1, 0]}
                      onHbr-page-changed={(event) => {
                        pageHandler(event);
                      }}
                    />
                  )}
                </div>
              )}
            </HbrAccordion>
          </div>
        )}
    </>
  );
};

InsightsView.propTypes = {
  timeFilter: PropTypes.object,
  setNotificationInsightLoader: PropTypes.func,
  setNotificationInsight: PropTypes.func,
  setNotificationInsightError: PropTypes.func,
  globalFilter: PropTypes.object.isRequired,
  overview: PropTypes.object,
};

export default connect(mapStateToProps)(AppHOC(InsightsView));
